import { Navigate, useLocation, Outlet } from "react-router-dom";

function ProtectedRoute({ user, requireRole }) {
  const location = useLocation();

   // Still loading user from storage
  if (user === undefined) {
    return null;
  }

  // Not logged in at all
  if (!user) {
    return <Navigate to="/" replace />;
  }

   // First login enforcement
  if (user.isFirstLogin && location.pathname !== "/admin/change-password") {
    return <Navigate to="/admin/change-password" replace />;
  }

  //Logged in but not assigned the required role
  if (requireRole && user.role !== requireRole) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}

export default ProtectedRoute;
